import React from 'react';
import { TickerBanner } from './components/TickerBanner';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { TransitionBlock } from './components/TransitionBlock';
import { NexusSection } from './components/NexusSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingBlock } from './components/PricingBlock';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="min-h-screen w-full font-body bg-brand-cream" data-id="element-0">
      <TickerBanner data-id="element-1" />
      <TopBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <IdentificationSection data-id="element-4" />
      <TransitionBlock data-id="element-5" />
      <NexusSection data-id="element-6" />
      <FeaturesSection data-id="element-7" />
      <PricingBlock id="precio" data-id="element-8" />
      <BonusSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <PricingBlock id="comprar" showValueTable data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <Footer data-id="element-13" />
      <StickyBar data-id="element-14" />
    </div>;
}